(() => {
  if (!customElements.get('asal-quote-carousel')) {
    customElements.define('asal-quote-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const track = this.querySelector('.asal-quote-track');
        const slides = Array.from(track.children);
        const controls = this.querySelector('.asal-quote-controls');
        if (!controls || slides.length < 2) return;
        controls.hidden = false;
        const previous = controls.querySelector('[data-quote-direction="-1"]');
        const next = controls.querySelector('[data-quote-direction="1"]');
        let index = 0;
        const update = () => {
          const left = track.getBoundingClientRect().left;
          index = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
          controls.querySelector('[data-quote-position]').textContent = `${index + 1} / ${slides.length}`;
          previous.disabled = index === 0;
          next.disabled = index === slides.length - 1;
        };
        const move = direction => {
          const target = slides[Math.max(0, Math.min(slides.length - 1, index + direction))];
          track.scrollBy({ left: target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        controls.addEventListener('click', event => {
          const button = event.target.closest('[data-quote-direction]');
          if (button) move(Number(button.dataset.quoteDirection));
        });
        track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        });
        track.addEventListener('scroll', update, { passive: true });
        update();
      }
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-asal-story-target]');
    if (!link || !link.getAttribute('href').startsWith('#') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.dataset.asalStoryTarget) || document.getElementById('asal-collection-products');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
  if (!customElements.get('asal-product-card')) {
    customElements.define('asal-product-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.select = this.querySelector('select[name="id"]');
        if (!this.select) return;
        this.originalImage = this.querySelector('.asal-card-photo')?.cloneNode();
        const variants = this.querySelector('.asal-card-variants');
        if (variants) {
          variants.hidden = false;
          this.select.hidden = true;
          this.querySelector('.asal-card-select-label').hidden = true;
        }
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-variant]');
          if (!button || this.querySelector('[aria-busy="true"]')) return;
          this.select.value = button.dataset.variant;
          this.updateVariant();
        });
        this.select.addEventListener('change', () => this.updateVariant());
      }
      updateVariant() {
        const option = this.select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        this.querySelectorAll('[data-variant]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.variant === option.value));
        });
        this.querySelectorAll('[data-variant-panel]').forEach(panel => {
          panel.hidden = panel.dataset.variantPanel !== option.value;
        });
        this.querySelectorAll('[data-product-link]').forEach(link => { link.href = option.dataset.url; });
        this.querySelector('[name="quantity"]').value = option.dataset.minimum || '1';
        const submit = this.querySelector('button[type="submit"]');
        if (submit) submit.disabled = !available;
        this.querySelectorAll('[data-cart-label]').forEach(label => {
          label.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
        });
        const inStock = option.dataset.stock !== 'false';
        this.querySelector('[data-availability]').textContent = !available ? 'Derzeit ausverkauft' : !inStock ? '● Bestellbar' : `● Auf Lager${this.dataset.delivery ? ` · Lieferung ${this.dataset.delivery}` : ''}`;
        const image = this.querySelector('.asal-card-photo');
        if (image && this.originalImage) {
          if (option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          } else {
            image.src = this.originalImage.src;
            if (this.originalImage.srcset) image.srcset = this.originalImage.srcset;
            else image.removeAttribute('srcset');
          }
        }
      }
    });
  }
  if (!customElements.get('asal-collection-grid')) {
    customElements.define('asal-collection-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        // Keep an unassigned development template through filtering and pagination.
        const preserveTemplate = event => {
          if (!event.detail?.url || !this.dataset.template) return;
          const url = new URL(event.detail.url, location.href);
          url.searchParams.set('view', this.dataset.template);
          event.detail.url = url.toString();
        };
        this.addEventListener('facet:criteria-changed', preserveTemplate, true);
        this.addEventListener('pagination:page-changed', preserveTemplate, true);
      }
    });
  }
})();
